import { BrowserSessionApiClient } from './browserSessionApiClient';

export type OutlookQuotationDraft = {
  prefill: {
    clientName: string;
    clientCompany?: string;
    clientEmail: string;
    clientMobile?: string;
    clientAddress?: string;
    projectAddress: string;
    suburb: string;
    postCode: string;
    projectDescription: string;
    includeStructuralScope: boolean;
    includeCivilScope: boolean;
  };
  source: { subject: string; fromName: string | null; fromEmail: string | null; attachmentNames: string[] };
  expiresAt: string;
};

export function isOutlookQuotationActionId(value: unknown): value is string {
  return typeof value === 'string' && /^outlook-action:[a-f0-9]{64}$/.test(value);
}

export function outlookQuotationOwnerIdentity(user: { userId?: string; userDetails?: string } | null): string {
  return user?.userId && user.userDetails ? `${user.userId}:${user.userDetails.trim().toLowerCase()}` : '';
}

const client = new BrowserSessionApiClient('/api');
export const outlookQuotationDraftService = {
  async getDraft(actionId: string): Promise<OutlookQuotationDraft> {
    if (!isOutlookQuotationActionId(actionId)) throw new Error('Invalid Outlook quotation reference.');
    const response = await client.request<{ data: OutlookQuotationDraft }>(
      `/api/v1/outlook/actions/${encodeURIComponent(actionId)}/quotation-draft`,
      { headers: { 'Cache-Control': 'no-store' } },
    );
    const draft = response?.data;
    if (!draft?.prefill || !draft?.source || !Array.isArray(draft.source.attachmentNames) || !Number.isFinite(Date.parse(draft.expiresAt))) {
      throw new Error('Invalid Outlook quotation draft response.');
    }
    return draft;
  },
};
